import React from "react";

import { DeletePopUp } from "../../../../../components/PopUp";
import {
  DateFormat,
  formatCurrency,
  formatDate,
  formatPercent,
} from "../../../../../utils";
import { ConfirmDetail } from "../../../../../components/PopUp/confirmShared/types";
import { DeleteInterestRateModalProps } from "./types";
import { FootNote } from "./styles";

export const DeleteInterestRateModal: React.FC<
  DeleteInterestRateModalProps
> = ({ isOpen, rate, onClose, onConfirm, isDeleting = false, deleteError }) => {
  const rateLabel = rate ? formatPercent(rate.interestRate, 3) : "";
  const effectiveLabel = rate
    ? `Took effect ${formatDate(rate.effectiveDate, DateFormat.DMY_SPACE)}`
    : "";
  const paymentLabel =
    rate?.paymentAmount !== null && rate?.paymentAmount !== undefined
      ? `${formatCurrency(rate.paymentAmount)}/mo`
      : null;
  const subtitle = [effectiveLabel, paymentLabel].filter(Boolean).join(" · ");

  const details: ConfirmDetail | undefined = rate
    ? { dot: "danger", title: `${rateLabel} rate`, subtitle }
    : undefined;

  return (
    <DeletePopUp
      isOpen={isOpen}
      setIsOpen={onClose}
      title="Delete interest rate"
      text={
        <>
          Do you really want to delete this rate period?
          <FootNote>
            <strong>This action cannot be undone.</strong>
          </FootNote>
          <FootNote>
            The payments in later periods will be calculated from the previous
            rate.
          </FootNote>
        </>
      }
      details={details}
      handleOnDelete={onConfirm}
      isLoading={isDeleting}
      errorMessage={deleteError}
    />
  );
};

DeleteInterestRateModal.displayName = "DeleteInterestRateModal";
